import ct from "class-types.macro";

import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import Stars from "~/common/Stars";
import { Product } from "~/common/Store/models/ProductListing";
import Ribbon from "~/productListing/ProductBox/Ribbon";

interface Props {
  product: Product;
}
const CarouselMember = ({ product }: Props) => {
  return (
    <li key={product.itemNumber} className="ag-item">
      <div className="product-image">
        <a href={product.link} title={product.description}>
          <noscript>
            <img alt={product.description} src={product.primaryImagePath} />
          </noscript>
          <img
            className="bLazyVisible"
            alt={product.description}
            src="//cdnimg.webstaurantstore.com/uploads/design/2014/1/blank.png"
            data-src={product.primaryImagePath}
          />
        </a>
      </div>
      <div className="details">
        {product.isWebstaurantPlusEligible && (
          <>
            <Ribbon
              bgcolor="lightBlue"
              href="/plus/"
              data-testid="itemPlus"
              className={ct("inline-block", "italic")}
            >
              plus
            </Ribbon>
          </>
        )}
        <Stars rating={product.overallRating} />
        <a
          href={product.link}
          data-target="title"
          className="description"
          title={product.description}
        >
          {product.description}
        </a>
        <div className="pricing" data-component="Pricing">
          <p className="price">
            {formatAsCurrency.formatIfUndefined(
              product.price.displaySalePrice
                ? product.price.salePrice
                : product.price.price,
            )}
            <span className="each">/{product.unitOfMeasure}</span>
          </p>
        </div>
      </div>
    </li>
  );
};

export default CarouselMember;
